var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    ref: "player",
    attrs: {
      "id": "videoHolder",
      "autoplay": "",
      "width": "100%",
      "controls": "",
      "controlsList": "nodownload"
    },
    on: {
      "ended": function($event) {
        _vm.playNext()
      }
    }
  }, [_c('source', {
    ref: "source",
    attrs: {
      "src": _vm.mediaPath,
      "type": "video/mp4"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e13353fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentViewer/contentHelper/videoPlayer.vue
// module id = 52KT
// module chunks = 1